(function ($) {
  // Utility for common functions
  var utils = require("./utils");

  // create the defaults once
  var pluginName = "jsTable";

  var $sectionHeader = $(
    '<tr class="govuk-table__row" id="tableHeaders">\
                                <th class="govuk-table__header" id="grant_section_uuid">Grant Section Uuid</th>\
                                <th class="govuk-table__header">Section Code</th>\
                                <th class="govuk-table__header">Section Name</th>\
                                <th class="govuk-table__header">Payment Day</th>\
                                <th class="govuk-table__header">Receipt Day</th>\
                                <th class="govuk-table__header">Nettable</th>\
                                <th class="govuk-table__header"><span class="visually-hidden">actionLinks</span></th>\
                            </tr>',
  );
  var initialJsonData = "";

  // the plugin constructor
  function Plugin(element, options) {
    this.$table = $(element);
    this.$inputFields = this.$table.find("#js-table-input");
    this.$sectionCodeFieldStatus = this.$table.find("#disableSectionCode");
    this.$tableModelMirror = this.$table.find(".js-table-object");
    this.$buttons = this.$table.find(".js-table-btn");

    this.options = $.extend({}, $.fn[pluginName].defaults, options);

    this._defaults = $.fn[pluginName].defaults;
    this._name = pluginName;

    this.init();
    initialJsonData = JSON.stringify($("#grantSectionObject").val());
  }

  Plugin.prototype = {
    init: function () {
      // initialisation logic goes here
      this.inputFieldsArray = this.getArrayOfInputs();
      this.tableModel = this.initialiseTableModel();

      this.updateHiddenJsTableModel();
      this.saveSectionCodeFieldStatusDetails();

      this.$buttons.on("click", this.sectionBtnClickEvent.bind(this));
    },
    updateHiddenJsTableModel: function () {
      this.$tableModelMirror.attr("value", JSON.stringify(this.tableModel));
    },
    saveSectionCodeFieldStatusDetails: function () {
      if (this.$sectionCodeFieldStatus.length) {
        $.extend(this.options, {
          disableSectionCodeField:
            this.$sectionCodeFieldStatus.val().toLowerCase() == "true"
              ? true
              : false,
        });
      }
    },
    getArrayOfInputs: function () {
      var self = this;
      var inputArray = [];

      var $elementsToBeModelled = self.$inputFields
        .find("input, select, textarea")
        .filter(function () {
          // Return only fields which are not [part of] a subset of markup generated by Chosen.js
          return $(this).parent(".chosen-search").length === 0;
        });

      $elementsToBeModelled.each(function (i, el) {
        var $el = $(el);
        var obj = {};

        obj.type = el.type;
        obj.name = el.name;
        obj.id = el.id;
        obj.ref = $el;
        obj.requireOr = $el.data("require-or");
        obj.defaultValue = $el.data("default-value");

        if (el.type === "radio") {
          // Radiobuttons are related by the 'name' attribute: the following fetches the group,
          // instead of the above $el, which fetches just a single radiobutton
          obj.ref = self.$inputFields.find(":radio[name='" + el.name + "']");
        }

        inputArray.push(obj);
      });

      // Perform one more check to be sure that values about to be returned are actually valid fields:
      // Temp object
      var obj = {};

      // Search and replace using the 'name' property as the unique identifier
      //  .... this is to cater to the 'name=nettable' radiobuttons)
      // @TODO Review to see if better alternative exists
      for (var i = 0, len = inputArray.length; i < len; i++) {
        obj[inputArray[i]["name"]] = inputArray[i];
      }

      // Refilling the inputArray with contents of the Temp object above
      inputArray = [];
      for (var key in obj) {
        inputArray.push(obj[key]);
      }

      return inputArray;
    },
    populateInputFields: function (rowObject) {
      var self = this;
      $(self.inputFieldsArray).each(function (index, inputFieldObject) {
        var $inputField = inputFieldObject.ref;

        switch (inputFieldObject.type) {
          case "select-one":
            if (isInLedgerPage()) {
              $inputField
                .val(rowObject[inputFieldObject.name])
                .trigger("chosen:updated");
            } else {
              $inputField
                .val(rowObject[inputFieldObject.name].value)
                .trigger("chosen:updated");
            }
            break;
          case "radio":
            if (isInGrantSectionsPage()) {
              if (rowObject[inputFieldObject.name] == "true") {
                $("#nettableYes").prop("checked", true);
              } else {
                $("#nettableNo").prop("checked", true);
              }
            }

            break;
          case "checkbox":
            var $selected = $inputField.filter(function () {
              return $(this).val() === rowObject[inputFieldObject.name];
            });

            $selected
              .parent(".selection-button-" + inputFieldObject.type)
              .addClass("selected");
            break;
          case "hidden":
          default:
            $inputField.val(rowObject[inputFieldObject.name]);
            break;
        }

        if ($inputField.attr("id") == "section_code") {
          // Determine whether or not to make it a 'disabled' field
          var action =
            self.options.disableSectionCodeField === false ? "remove" : "add";
          $inputField[action + "Class"]("disabled").attr(
            "disabled",
            self.options.disableSectionCodeField,
          );
        }
      });
      return;
    },
    resetInputs: function () {
      var self = this;
      $(self.inputFieldsArray).each(function (key, inputObject) {
        var $el = inputObject.ref;

        switch (inputObject.type) {
          case "select-one":
            // Poperly reset chosen.js field to default state
            $el.val("").trigger("chosen:updated");
            break;

          case "checkbox":
          case "radio":
            $el
              .parent(".selection-button-" + inputObject.type)
              .removeClass("selected");
            break;

          default:
            $el.val("");
            $el.removeClass("govuk-button--disabled").attr("disabled", false);
        }
      });
      //            $("#nettableNo").trigger( "click" );
    },
    fetchInputFields: function () {
      var obj = {};
      var self = this;

      $(self.inputFieldsArray).each(function (key, inputFieldObject) {
        var $inputField = inputFieldObject.ref;

        switch (inputFieldObject.type) {
          case "select-one":
            obj[inputFieldObject.name] = {
              value: $inputField.find(":selected").val(),
              text: $inputField.find(":selected").text(),
            };

            break;

          case "radio":
          case "checkbox":
            var $selected = $inputField.filter(function () {
              return (
                $(this).parent(
                  ".selection-button-" + inputFieldObject.type + ".selected",
                ).length === 1
              );
            });

            obj[inputFieldObject.name] = $selected.val();
            break;

          case "hidden":
            obj[inputFieldObject.name] =
              $inputField.val() ||
              "uuid-" + (self.getArrayOfTableContents().length + 1);
            break;

          default:
            var isEmpty = $inputField.val() == "";
            var isRequireOrEmpty = $(inputFieldObject.requireOr).val()
              ? $(inputFieldObject.requireOr).val() == ""
              : true;

            if (!isEmpty || !isRequireOrEmpty) {
              obj[inputFieldObject.name] = $inputField.val()
                ? $inputField.val()
                : inputFieldObject.defaultValue;
            } else {
              obj[inputFieldObject.name] = undefined;
            }
        }
      });
      return obj;
    },
    initialiseTableModel: function () {
      var self = this;

      var $jstable = self.$table;


      var id = $jstable.get(0).id;


      var tbl = {};

      tbl[id] = $("#" + id + " tr:has(td)")
        .filter(function () {
          return $(this).closest("#js-table-input").length === 0;
        })
        .map(function (i, v) {
          var $tds = $("td", this);
          var temp = {};

          $tds
            .filter(function () {
              return $(this).hasClass("grant_section_actions") == false;
            })
            .each(function (j, td) {
              var key =
                self.inputFieldsArray[j].name || self.inputFieldsArray[j].id;
              temp[key] = $(td).eq(0).text();

              // For select-one ==> chosen.js component:
              // if the type in the INPUT_ARRAY matches the data-type attribute defined on the <td> element
              if (
                self.inputFieldsArray[j].type == "select-one" &&
                $(td).data("type") == "select-one"
              ) {
                $(td.attributes).each(function (k, attr) {
                  if (attr["name"] == "data-val") {
                    temp[key] = {
                      value: attr["value"],
                      text: $(td).eq(0).text(),
                    };
                  }
                });
              }
            });

          return temp;
        })
        .get();

      return tbl;
    },
    getArrayOfTableContents: function () {
      return this.tableModel[this.$table.attr("id")];
    },
    addToTableModel: function (_rowDataObject) {
      //            _rowDataObject["destinationCode"] = _rowDataObject["destinationCode"]+"/"+_rowDataObject["vatCode"]+"/"+_rowDataObject["destinationType"];

      //            delete _rowDataObject["destinationCode"];
      //            delete _rowDataObject["vatCode"];
      //            delete _rowDataObject["destinationType"];

      var rowId = $("#rowId").val();

      this.getArrayOfTableContents().splice(rowId, 0, _rowDataObject);
      $("#ledgerTable").trigger("rowAddOrRemove");
      $("#rowId").val("0");
      //            if(isInGrantSectionsPage()) {
      //                $('#saveSectionBtn').show();
      //                $('#cancelAllChanges').show();
      //            }

      this.updateHiddenJsTableModel(); // Render to the hidden DOM field tracking tableModel
    },
    removeFromTableModel: function (_rowId) {
      var _removedRowObject = this.getArrayOfTableContents().splice(_rowId, 1);

      this.updateHiddenJsTableModel(); // Render to the hidden DOM field tracking tableModel
      return _removedRowObject[0];
    },
    renderTableModel: function () {
      var self = this;

      // Variable to determine when to disable the jstable Action links
      var inEditingMode = false;
      if (arguments.length && arguments[0] === true) {
        inEditingMode = true;
      }

      var $newTbody;
      if (isInGrantSectionsPage()) {
        $newTbody = $("<tfoot />");
      } else {
        $newTbody = $("<tbody />");
      }

      var $link, $edit, $remove;

      var contentArray = self.getArrayOfTableContents();

      //            contentArray.splice(0,1);

      // test, used below, to determine whether or not to show the 'edit' or 'remove' buttons
      var shouldShowEditButton = self.options.showEditBtnLink == "true";
      var shouldShowRemoveButton = self.options.showRemoveBtnLink == "true";

      // iteration through the stored table model, so as to render said model to view
      $.each(contentArray, function (contentKey, contentValue) {
        var $row = $('<tr class="govuk-table__row"/>');

        $link = $("<td />").addClass("grant_section_actions govuk-table__cell");

        // using the previously done test for the 'edit'/'remove' buttons
        if (shouldShowEditButton && shouldShowRemoveButton) {
          if (isInGrantSectionsPage()) {
            $edit = $(
              '<button type="button" class="js-table-btn js-table-edit" data-buttontype="edit" data-id="' +
                contentKey +
                '">edit</button>',
            ).on("click", self.sectionBtnClickEvent.bind(self));
          } else {
            $edit = $(
              '<button type="button" class="js-table-btn" data-buttontype="edit" data-id="' +
                contentKey +
                '">edit</button>',
            ).on("click", self.sectionBtnClickEvent.bind(self));
          }
          $remove = $(
            '<button type="button" class="js-table-btn" data-buttontype="remove" data-id="' +
              contentKey +
              '">remove</button>',
          ).on("click", self.sectionBtnClickEvent.bind(self));

          $link.append($edit).append("/").append($remove);
        } else if (shouldShowRemoveButton) {
          $remove = $(
            '<button type="button" class="js-table-btn" data-buttontype="remove" data-id="' +
              contentKey +
              '">remove</button>',
          ).on("click", self.sectionBtnClickEvent.bind(self));

          $link.append($remove);
        } else if (shouldShowEditButton) {
          if (isInGrantSectionsPage()) {
            $edit = $(
              '<button type="button" class="js-table-btn js-table-edit" data-buttontype="edit" data-id="' +
                contentKey +
                '">edit</button>',
            ).on("click", self.sectionBtnClickEvent.bind(self));
          } else {
            $edit = $(
              '<button type="button" class="js-table-btn" data-buttontype="edit" data-id="' +
                contentKey +
                '">edit</button>',
            ).on("click", self.sectionBtnClickEvent.bind(self));
          }

          $link.append($edit);
        }
        var tableArray = [];

        // Loading in the values for the first cells of the row
        $(self.inputFieldsArray).each(function (inputKey, inputValue) {
          var $cell = $('<td class="govuk-table__cell"/>');
          //                    if(!isInLedgerPage()){
          if (inputValue.name == "grantSectionUuid") {
            $cell.attr("headers", "grant_section_uuid");
          }
          var fieldName = inputValue.name;

          $cell.text(contentValue[inputValue.name]);

          if (
            fieldName == "destinationCode" ||
            fieldName == "destinationType"
          ) {
            tableArray = contentValue[inputValue.name].text;
            return false;
          } else if (fieldName == "vatCode") {
            tableArray = contentValue[inputValue.name].text;
          }

          if (inputValue.type == "select-one") {
            $cell.text(contentValue[inputValue.name].text);
            $cell
              .attr("data-type", inputValue.type)
              .attr("data-val", contentValue[inputValue.name].value);
          }

          $row.append($cell);

          //                    }
        });

        $row.append($link); // The last cell for each row is '$link'
        $newTbody.append($row);
      });

      // Disable all the Action links (i.e. with className 'grant_section_actions')
      if (inEditingMode) {
        utils.disableAllLinks($newTbody.find(".grant_section_actions"));
      }
      if (isInGrantSectionsPage()) {
        $newTbody.children("tr:first").before($sectionHeader);
        self.$table.children("tfoot").replaceWith($newTbody);
        var currentTableJson = JSON.stringify($("#grantSectionObject").val());

        if (currentTableJson == initialJsonData) {
          $("#saveSectionBtn").hide();
          $("#cancelAllChanges").hide();
          $("#notification").attr("hidden", "hidden");
        } else {
          $("#saveSectionBtn").show();
          $("#cancelAllChanges").show();
          $("#notification").removeAttr("hidden");
        }
      } else {
        self.$table.children("tbody").replaceWith($newTbody);
      }
    },

    /*
     *   The following function block probably deserves to be on the exposed
     *   'fn' namespace, so others can extend it to include other types of
     *   'sectionBtn's
     */
    sectionBtnClickEvent: function (e) {
      e.preventDefault();
      var self = this;
      var $sectionBtn = $(e.target);
      var buttonType = $sectionBtn.attr("data-buttontype");

      switch (buttonType) {
        case "update":
          this.updateJsTable(e);
          break;
        case "add":
          this.addToJsTable(e);
          break;
        case "edit":
          this.editJsTable(e);
          break;
        case "remove":
          this.removeFromJsTable(e);
          break;
        case "cancel":
          this.cancelChangesInTable(e);
          break;
        default:
          break;
      }
    },
    updateJsTable: function (e) {
      var _buttonType = $(e.target).attr("data-buttontype");

      var rowDataObject = this.fetchInputFields();
      if (isInLedgerPage()) {
        var vatCode;
        if (rowDataObject["vatCode"] == "true") {
          rowDataObject["vatCode"] = "A7";
        } else {
          rowDataObject["vatCode"] = "V7";
        }

      } else {
        var nettable = $("#nettableYes").is(":checked");
        rowDataObject["nettable"] = nettable;
        $("#saveSectionBtn").removeAttr("disabled");
        $(".js-table-edit").removeClass("govuk-button--disabled");
      }

      var allInputsFilledCorrectly = Object.keys(rowDataObject).every(
        function (key, index, keysArray) {
          return rowDataObject[key] != undefined;
        },
      );

      if (allInputsFilledCorrectly) {
        this.toggleThisButtonType(this.fetchToggleButton(_buttonType));
        this.addToTableModel(rowDataObject);
        this.renderTableModel();
        this.resetInputs();
        if (isInGrantSectionsPage()) {
          $("#sectionValidation").text("");
          $("#unEditedRowObject").val("");
          $("#grantSection tbody").attr("hidden", "hidden");
          $("#addNewSection").show();
        }
      } else if (isInGrantSectionsPage()) {
        $("#sectionValidation").text(
          "Please provide details in the mandatory fields",
        );
      }
    },
    addToJsTable: function (e) {
      var self = this;
      if (self.$table.closest("#approvalThresholds").length &&
          !require("./thresholdValidation")(self.$table)) {
        return;
      }
      var rowDataObject = this.fetchInputFields.call(self);
      if (isInLedgerPage()) {

        var vatCode;
        if (rowDataObject["vatCode"] == "true") {
          rowDataObject["vatCode"] = "A7";
        } else {
          rowDataObject["vatCode"] = "V7";
        }
        rowDataObject["accountType"] = rowDataObject["accountType"].value;
        rowDataObject["destinationType"] =
          rowDataObject["destinationType"].value;
        rowDataObject["grantSectionCode"] =
          rowDataObject["grantSectionCode"].value;

      }

      if (isInGrantSectionsPage()) {
        var nettable = $("#nettableYes").is(":checked");
        rowDataObject["nettable"] = nettable;
      }

      var allInputsFilledCorrectly = Object.keys(rowDataObject).every(
        function (key, index, keysArray) {
          var status;

          if ($.isPlainObject(rowDataObject[key])) {
            status = Object.keys(rowDataObject[key]).every(function (objKey) {
              return rowDataObject[key][objKey] != "";
            });
          } else {
            status = rowDataObject[key] != undefined;
          }

          return status;
        },
      );

      if (allInputsFilledCorrectly) {
        this.addToTableModel.call(self, rowDataObject);
        this.renderTableModel.call(self);
        this.resetInputs.call(self);
        if (isInGrantSectionsPage()) {
          $("#sectionValidation").text("");
          $("#grantSection tbody").attr("hidden", "hidden");
          $("#addNewSection").show();
        }
      } else if (isInGrantSectionsPage()) {
        $("#sectionValidation").text(
          "Please provide details in the mandatory fields",
        );
      }
    },
    removeFromJsTable: function (e) {
      if (!isInLedgerPage()) {
        var rowId = $(e.target).data("id");
        $("#rowId").val(rowId);
        var nettable = $("#grantSection tr:last").find("td:eq(5)").text();

        var removedRowObject = this.removeFromTableModel.call(this, rowId);

        if (isInGrantSectionsPage()) {
          removedRowObject["nettable"] = nettable;
        }


        this.renderTableModel.call(
          this,
          e.target.dataset.buttontype == "edit" ? true : undefined,
        );
        this.resetInputs.call(this);

        //                $('#saveSectionBtn').show();
        //                $('#cancelAllChanges').show();

        return removedRowObject;
      }
    },
    cancelChangesInTable: function (e) {
      var actionBtnText = $(".js-new-grant-add").text();
      if (actionBtnText == "Add section") {
        this.resetInputs();
      } else {
        this.toggleThisButtonType(this.fetchToggleButton("update"));

        var unEditedRowObject = JSON.parse($("#unEditedRowObject").val());
        $("#saveSectionBtn").removeAttr("disabled");

        this.addToTableModel(unEditedRowObject);
        this.renderTableModel();
        this.resetInputs();
      }
      $("#unEditedRowObject").val("");
      $("#sectionValidation").text("");
      //            $("#saveSectionBtn").hide();
      //            $("#cancelAllChanges").hide();
      $("#grantSection tbody").attr("hidden", "hidden");
      $("#addNewSection").show();
      $(".js-table-edit").removeClass("govuk-button--disabled");
    },
    editJsTable: function (e) {
      if (!isInLedgerPage()) {
        var self = this;
        var _buttonType = "add";

        this.toggleThisButtonType(this.fetchToggleButton(_buttonType));

        var dataRowObjectBeingEdited = this.removeFromJsTable(e);
        $("#grantSection tbody").removeAttr("hidden");
        $("#addNewSection").hide();
        $("#saveSectionBtn").attr("disabled", "disabled");
        $("#unEditedRowObject").val(JSON.stringify(dataRowObjectBeingEdited));
        $("#sectionValidation").text("");
        $("#js-table-input h3").text("Update section");
        $(".js-table-edit").addClass("govuk-button--disabled");

        this.populateInputFields(dataRowObjectBeingEdited);
      }

      // this.$buttons.removeClass('disabled');
      // this.$buttons.addClass('disabled');
    },

    /*
     *   The following function block probably deserves to be on the exposed
     *   'fn' namespace, so others can extend it to cater to other
     *   'sectionBtn's toggling
     */
    toggleThisButtonType: function (toBeToggledObject) {
      if (!$.isPlainObject(toBeToggledObject)) {
        console.log(
          "The argument you supplied was not of the expected Onject type",
        );
        return false;
      }

      // @TODO review the scalability of this implementation...
      if (
        toBeToggledObject.originIndex != -1 &&
        toBeToggledObject.replacementElement.length
      ) {
        switch (toBeToggledObject.type) {
          case "update":
            toBeToggledObject.replacementElement
              .attr("data-buttontype", "add")
              .attr("value", this.options.addBtnText)
              .text(this.options.addBtnText)
              .removeClass("js-new-grant-update")
              .addClass("js-new-grant-add");

            break;
          case "add":
            toBeToggledObject.replacementElement
              .attr("data-buttontype", "update")
              .attr("value", this.options.updateBtnText)
              .text(this.options.updateBtnText)
              .removeClass("js-new-grant-add")
              .addClass("js-new-grant-update");

            break;
          default:
            break;
        }

        // Perform the replacement
        $(toBeToggledObject.originalElement)
          .after(toBeToggledObject.replacementElement)
          .remove();

        // Re-cache the collection of js-table-btns
        this.$buttons = this.$table.find(".js-table-btn");

        toBeToggledObject.replacementElement.on(
          "click",
          this.sectionBtnClickEvent.bind(this),
        );
      } else {
        console.log(
          "The object for the button to be toggled looks like it has a wrong structure",
        );
      }

      return true;
    },
    fetchToggleButton: function (buttontype) {
      // Check that function argument is of the expected type
      if (typeof buttontype != "string") {
        return { type: undefined, element: null };
      }

      /*
       *   Fetch the button with that 'data' attributes set as follows
       *   @TODO Review this: it might return a collection, instead of
       *   a single jQuery object
       */
      var $toBeToggled = this.$buttons.filter(function () {
        return (
          $(this).attr("data-buttontype").toLowerCase() === buttontype &&
          $(this).data("will-toggle")
        );
      });

      // Hack: simply accept the first one!
      if ($toBeToggled.length > 1) {
        $toBeToggled = $toBeToggled.first();
      }

      // Capture this info for when the replacement is to happen
      var btnIndex = this.$buttons.index($toBeToggled);

      return {
        type: buttontype,
        originIndex: btnIndex,
        originalElement: $toBeToggled,
        replacementElement: $toBeToggled.clone(),
      };
    },
  };

  // Reference: https://www.smashingmagazine.com/2011/10/essential-jquery-plugin-patterns/ ; Aug 2017 ; Chie

  /**
   *
   * lightweight plugin wrapper around the constructor to prevent
   * against multiple instantiations
   *
   **/

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  };

  function isInLedgerPage() {
    return $("#ledgerTable").length > 0;
  }
  function isInGrantSectionsPage() {
    return $("#grant-sections-page").length > 0;
  }

  // Reference: http://ryanflorence.com/use-your-fn-jquery-namespace/ ; Sept 2017 ; Chie

  /**
   *
   * attaching the 'defaults' object to the 'fn' namespace so as to offer
   * developers access to decide what the defaults should be for their
   * particular application
   *
   **/

  $.fn[pluginName].defaults = {
    showEditBtnLink: "true",
    showRemoveBtnLink: "true",
    updateBtnText: "Update section",
    addBtnText: "Add section",
  };

  $("#addNewSection").click(function () {
    $(".js-table tbody").removeAttr("hidden");
    $(".js-table .js-table-edit").removeClass("govuk-button--disabled");
    //        $('#saveSectionBtn').show();
    //        $('#cancelAllChanges').show();
    $("#saveSectionBtn").removeAttr("disabled");
    $("#js-table-input h3").text("Add section");
    $(this).attr("hidden", "hidden");
    $(this).hide();
  });
  $("#saveSectionBtn").hide();
  $("#cancelAllChanges").hide();
})(jQuery);
